var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0715 62.8989C99.8504 34.364 66.6755 16.1876 56.6013 11.4236C46.5271 6.65954 39.0885 8.88652 28.848 21.6654C18.6076 34.4442 20.0477 56.5179 19.8988 65.8221C19.7499 75.1263 37.3478 98.5676 72.0715 62.8989Z",
    fill: "#94DEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1169 69.7671V58.5927C59.1169 54.9598 57.6737 51.4758 55.1049 48.907C52.5361 46.3382 49.0521 44.895 45.4192 44.895H18.0239C14.391 44.895 10.9069 46.3382 8.33813 48.907C5.76932 51.4758 4.32617 54.9598 4.32617 58.5927V69.7671",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7209 38.8373C38.8877 38.8373 44.6976 33.0274 44.6976 25.8605C44.6976 18.6937 38.8877 12.8838 31.7209 12.8838C24.554 12.8838 18.7441 18.6937 18.7441 25.8605C18.7441 33.0274 24.554 38.8373 31.7209 38.8373Z",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9292 51.6819C37.6122 51.3586 37.2357 51.1021 36.8213 50.9271C36.407 50.7522 35.9628 50.6621 35.5143 50.6621C35.0658 50.6621 34.6217 50.7522 34.2073 50.9271C33.7929 51.1021 33.4165 51.3586 33.0994 51.6819L32.4413 52.3525L31.7833 51.6819C31.1428 51.0291 30.2741 50.6624 29.3684 50.6624C28.4626 50.6624 27.5939 51.0291 26.9534 51.6819C26.3129 52.3346 25.9531 53.2199 25.9531 54.143C25.9531 55.0661 26.3129 55.9514 26.9534 56.6041L27.6115 57.2748L32.4413 62.197L37.2712 57.2748L37.9292 56.6041C38.2465 56.281 38.4981 55.8973 38.6698 55.475C38.8415 55.0527 38.9299 54.6001 38.9299 54.143C38.9299 53.6859 38.8415 53.2333 38.6698 52.811C38.4981 52.3887 38.2465 52.005 37.9292 51.6819V51.6819Z",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.12d5e150.svg";
export { ForwardRef as ReactComponent };